import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import {
  Checkbox, Chip, DialogContent, Grid, List, ListItemButton, ListItemIcon, ListSubheader,
  // MenuItem
} from '@mui/material';
// import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';
import PropTypes from 'prop-types';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { dataConstants } from '../../../constants';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { SortableContainer, SortableElement } from '../../_common/SortableHOC';
import DragHandleRoundedIcon from '@mui/icons-material/DragHandleRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import SortRoundedIcon from '@mui/icons-material/SortRounded';
import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';
// import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import * as send from '../../../../lib/analytics/send';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import { defaultCols } from '../../../hook/useScreenerState';

const SortableItem = SortableElement(({ value, handleDelete }) => (
  // <Box component="li" sx={{ zIndex: 1301, display: 'flex', alignItems: 'center', mr: 2 }}>
  <ListItem sx={{ p: 0 }}>
    <Chip label={value?.name}
      // onDelete={handleDelete}
      avatar={<DragHandleRoundedIcon />}
      // deleteIcon={<CloseRoundedIcon sx={{ zIndex: 9999, fontSize: '20px !important' }} />}
      sx={{
        width: '150pxx', textAlign: 'left', pr: 1,
        borderRadius: '0px', height: '37px',
        '& .MuiChip-label': { px: '20px', mr: 'auto' },
        cursor: 'grab', background: 'transparent', border: '1px solid #c0c0c052', border: 0
      }}
    />
  </ListItem>
  //   <IconButton size="small" onClick={() => handleDelete(value)}>
  //     <CloseRoundedIcon fontSize="small" sx={{ zIndex: 9999, fontSize: '20px !important' }} />
  //   </IconButton>
  // </Box>
));

const SortableList = SortableContainer(({ items, handleDelete }) => {
  const filteredArray = items?.filter(item => item?.name !== "");
  return (
    <List sx={{ width: '100%', py: 0 }}>
      <ListSubheader sx={{ zIndex: 1301 + 1, background: '#fbfbfc', px: 1, py: .5, color: 'primary.main' }}>
        {/* <SortRoundedIcon sx={{ fontSize: '1.2rem', verticalAlign: 'sub' }} /> */}
        Columns Order:
      </ListSubheader>
      {filteredArray?.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value} handleDelete={handleDelete} />
      ))}
    </List>
  );
});

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const { DEFAULT_TBL_COLS } = dataConstants;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ManageColumnsDialog({ arrayOrder, columns, setColumnGroups, setColumns, onSortEnd, handleDelete, }) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCheckboxChange = (item) => {
    // Check if the item is already in the selectedItems array
    const index = selectedItems?.findIndex((selectedItem) => selectedItem?.name === item?.name);

    if (index === -1) {
      // If not, add it to the selectedItems array
      setSelectedItems([...selectedItems, item]);
      handleColumns([...selectedItems, item])
    } else {
      // If it's already selected, remove it from the array
      const updatedItems = [...selectedItems];
      updatedItems.splice(index, 1);
      setSelectedItems(updatedItems);
      handleColumns(updatedItems)
    }
  };

  // Group the data by label
  const groupedData = DEFAULT_TBL_COLS?.slice(2)?.reduce((acc, item) => {
    if (!acc[item.label]) {
      acc[item.label] = [];
    }
    acc[item.label].push(item);
    return acc;
  }, {});

  const handleClickOpen = (e) => {
    setOpen(true);
    send.uevent(e)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleReset = () => {
    const resetCols = [...defaultCols];
    setSelectedItems(resetCols);
    setColumns(resetCols);
    setColumnGroups(updateColSpanAndIncludeCols(arrayOrder, resetCols));
  };


  // const sortSelectedItems = (selectedItems, arrayOrder) =>
  //   arrayOrder?.reduce((acc, { name }) => [...acc, ...selectedItems?.filter((item) => item?.label === name)], [])
  //     ?.concat(selectedItems?.filter((item) => !arrayOrder?.some((orderItem) => orderItem?.name === item?.label)));

  // const sortedSelectedItems = sortSelectedItems(selectedItems, arrayOrder);

  const updateColSpanAndIncludeCols = (arrayOrder, selectedItems) =>
    arrayOrder.map((orderItem) => ({
      ...orderItem,
      colSpan: orderItem?.name === '' ? orderItem?.colSpan : selectedItems?.filter((item) => item?.label === orderItem?.name)?.length?.toString(),
      includeCols: orderItem?.name === '' ? orderItem?.includeCols : selectedItems?.filter((item) => item?.label === orderItem?.name).map((item) => item?.field),
    }));

  const updatedArrayOrder = updateColSpanAndIncludeCols(arrayOrder, selectedItems);

  const handleColumns = (_selectedItems) => {
    // const reqObjs = [
    //   { "name": "Ticker", "tooltip": "Ticker", "field": "ticker", "urlField": "ticker", "class": "text-left", sortFunc: (a, b) => a.localeCompare(b) },
    //   { "name": "Name", "tooltip": "Name", "field": "tickername", "class": "td-color", "urlField": "ticker" },
    // ]
    // const uniqueSortedSelectedItems = sortSelectedItems(_selectedItems, arrayOrder)?.filter(
    //   (item) => !reqObjs.some((newItem) => newItem?.name === item?.name)
    // );

    // setColumns([...reqObjs, ...uniqueSortedSelectedItems])
    setColumns(_selectedItems)
    setColumnGroups(updatedArrayOrder)
    // setOpen(false);
  };

  const countSelectedItems = (label) => {
    const items = groupedData[label];
    const selectedCount = items?.filter(item => selectedItems?.some(selected => (
      item.name === selected?.name && item?.field === selected?.field
    )))?.length;
    return selectedCount;
  }

  React.useEffect(() => {
    setSelectedItems(columns)
  }, [columns])

  return (
    <>
      <LightTooltip describeChild title="Manage Columns" placement="top" disableInteractive>
        <IconButton
          onClick={handleClickOpen} sx={{ mr: 1 }}
          data-event-name="manage-column"
          data-event-category="stock-screener"
          data-event-label="csv"
        >
          <ViewColumnRoundedIcon fontSize="small" sx={{ color: '#434166', pointerEvents: 'none' }} />
        </IconButton>
      </LightTooltip>
      {/* <MenuItem onClick={handleClickOpen}
      // disabled={isSystemDefault}
      >
        <ListItemIcon>
          <ViewColumnRoundedIcon fontSize="small" />
        </ListItemIcon>
        <Typography variant="inherit" noWrap fontSize="small" >
          Manage Columns
        </Typography>
      </MenuItem> */}
      <Dialog
        fullScreen={!matches}
        // fullWidth={true}
        maxWidth={'md'}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative', zIndex: 1304 }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Manage Columns
            </Typography>
            <Button color="inherit" onClick={handleReset} startIcon={<RestartAltRoundedIcon />} sx={{ textTransform: "none", mr: 1 }}>
              Reset
            </Button>
            <Button autoFocus color="inherit" onClick={handleClose} sx={{ textTransform: "none", background: '#ffffff21', '&:hover': { background: '#ffffff29' } }}>
              Save Changes
            </Button>
          </Toolbar>
        </AppBar>
        {/* <List>
          <ListItem button>
            <ListItemText primary="Phone ringtone" secondary="Titania" />
          </ListItem>
          <Divider />
          <ListItem button>
            <ListItemText
              primary="Default notification ringtone"
              secondary="Tethys"
            />
          </ListItem>
        </List> */}
        <DialogContent className="manage-column-dialog" sx={{ p: 0, }}>
          <Grid container spacing={2}>
            <Grid size={{ md: 3, sm: 3.5, xs: 12 }}>
              <Tabs
                orientation={!matches ? "horizontal" : "vertical"}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                selectionFollowsFocus
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs"
                sx={{
                  [`& .${tabsClasses.scrollButtons}`]: {
                    height: '32px',
                    '&.Mui-disabled': {
                      opacity: 0.3
                    },
                  },
                  borderRight: 1, borderColor: 'rgb(0 0 0 / 6%)', maxHeight: { md: 423, sm: 423 }, background: '#f5f6f7', height: matches ? '100%' : '',
                  '& .MuiButtonBase-root.Mui-selected': { background: '#020e4a17', fontWeight: '600', color: 'primary.main' },
                  '& .MuiButtonBase-root': { color: 'rgb(60,64,67)' },
                }}
              >
                {Object.keys(groupedData)?.sort()?.map((label, index) => (
                  <Tab
                    label={label === 'undefined' ? 'Others' : label}
                    key={index}
                    iconPosition="end"
                    icon={<Chip label={countSelectedItems(label)} sx={{ height: '20px', '& .MuiChip-label': { px: .8, color: 'rgba(0, 0, 0, 0.6)', fontWeight: 600 } }} />}
                    sx={{ textTransform: 'none', minHeight: '40px', '&.MuiTab-root': { justifyContent: 'start', fontSize: '.9rem' } }} />
                ))}
              </Tabs>
            </Grid>
            <Grid size={{ md: 6, sm: 5, xs: 12 }} sx={{ '& .MuiBox-root': { padding: '4px' } }}>
              {Object.keys(groupedData)?.sort()?.map((label, index) => (
                <TabPanel key={`tab-${label}-${index}`} value={value} index={index} sx={{ width: '100%', }}>
                  <ListSubheader sx={{ px: 1, background: "#fff", color: 'primary.main', fontSize: '.9rem' }}>{label === 'undefined' ? 'Others' : label}:</ListSubheader>
                  {value === index && (
                    <Grid container sx={{
                      p: '0 !important', maxHeight: { md: 350, sm: 350 }, overflow: 'scroll',
                      '&::-webkit-scrollbar-thumb': {
                        background: '#020e4a85',
                        borderRadius: '1px'
                      },
                      '&::-webkit-scrollbar-track': {
                        borderRadius: '1px'
                      },
                      '&::-webkit-scrollbar': {
                        width: '5px !important'
                      }
                    }}>
                      {groupedData[label]?.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))?.map((item, itemIndex) => (
                        <Grid size={{ xs: 6, sm: 6, md: 6 }} key={itemIndex} sx={{ p: '0 !important', maxHeight: { md: 423, sm: 423 }, overflow: 'scroll', }}>
                          <ListItem key={itemIndex} disablePadding>
                            <LightTooltip describeChild title={item?.tooltip} placement="top" disableInteractive>
                              <ListItemButton role={undefined} onClick={() => handleCheckboxChange(item)} dense sx={{ px: '12px', py: '6px', '& .MuiListItemText-secondary': { display: 'none' }, '&:hover .MuiListItemText-secondary': { display: 'block' } }}>
                                <ListItemIcon sx={{ minWidth: '32px' }}>
                                  <Checkbox
                                    edge="start"
                                    sx={{ padding: '0 5px' }}
                                    checked={selectedItems?.some((selectedItem) => selectedItem?.name === item?.name)}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': item?.field }}
                                  />
                                </ListItemIcon>
                                <ListItemText id={item?.field} primary={item?.name} />
                              </ListItemButton>
                            </LightTooltip>
                          </ListItem>
                          {/* <Checkbox
                              checked={selectedItems.some((selectedItem) => selectedItem.name === item.name)}
                              onChange={() => handleCheckboxChange(item)}
                            />
                            {item.name} */}
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </TabPanel>
              ))}
            </Grid>
            <Grid size={{ md: 3, sm: 3.5, xs: 12 }}
              // sx={{ display: { xs: 'none', md: 'block', sm: 'block' } }}
              sx={{
                width: '100%', background: '#fbfbfc',
                // filter: open ? 'blur(3px)' : 'unset',
                borderLeft: 1, borderColor: 'rgb(0 0 0 / 5%)', height: '100%',
                maxHeight: { md: 423, sm: 423 }, overflow: 'auto',
                '&::-webkit-scrollbar-thumb': {
                  background: '#020e4a85',
                  borderRadius: '1px'
                },
                '&::-webkit-scrollbar-track': {
                  borderRadius: '1px'
                },
                '&::-webkit-scrollbar': {
                  width: '5px !important'
                }
              }}>
              <SortableList
                items={columns}
                onSortEnd={onSortEnd}
                handleDelete={handleCheckboxChange}
              // hideSortableGhost={false}
              />
            </Grid>
          </Grid>
          {/* <TabPanel value={value} index={0}>
            Item One
          </TabPanel>
          <TabPanel value={value} index={1}>
            Item Two
          </TabPanel>
          <TabPanel value={value} index={2}>
            Item Three
          </TabPanel>
          <TabPanel value={value} index={3}>
            Item Four
          </TabPanel>
          <TabPanel value={value} index={4}>
            Item Five
          </TabPanel>
          <TabPanel value={value} index={5}>
            Item Six
          </TabPanel>
          <TabPanel value={value} index={6}>
            Item Seven
          </TabPanel> */}
        </DialogContent>
      </Dialog>
    </>
  );
}
